import { render, staticRenderFns } from "./BatchRunBadge.vue?vue&type=template&id=f525cbd8&scoped=true"
import script from "./BatchRunBadge.vue?vue&type=script&lang=js"
export * from "./BatchRunBadge.vue?vue&type=script&lang=js"
import style0 from "./BatchRunBadge.vue?vue&type=style&index=0&id=f525cbd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525cbd8",
  null
  
)

export default component.exports